/**
 * TODO - replace own NotificationComponent with a component from ui-components when an alternative components will
 * be prepared because BAlert component is unusable in responsive design.
 */

import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { Notification as NotificationComponent } from '../../components'
import { ReduxState } from '../../types'
import { errorHandler } from '../../hoc'
import {
  NotificationMessage,
  NotificationState,
  NotificationSeverityEnum,
} from '../../redux/reducers/notification/model'
import { notificationActions } from '../../redux'

import styles from './styles.scss'

const severityToColorMap = {
  [NotificationSeverityEnum.Error]: 'error',
  [NotificationSeverityEnum.Warning]: 'warning',
  [NotificationSeverityEnum.Normal]: 'success',
}

interface Props {
  notifications: NotificationState
  hideNotification: any
}

export const Notification = (props: Props) => {
  const keys = Object.keys(props.notifications)

  return (
    <div className={styles.Notification}>
      {keys.map((key: string) => {
        const item: NotificationMessage = props.notifications[key]
        return (
          <NotificationComponent
            description={item.content}
            key={key}
            onClose={() => props.hideNotification(key)}
            title={item.title}
            type={severityToColorMap[item.severity]}
          />
        )
      })}
    </div>
  )
}

export default compose(
  errorHandler('containers/Notification/Notification.tsx'),
  connect(
    (state: ReduxState) => ({
      notifications: state.notification,
    }),
    {
      hideNotification: notificationActions.hideNotification,
    }
  )
)(Notification)
